import React from "react";
import { ConfigProvider, Flex, Skeleton } from "antd";

type IdCardSkeletonProps = {
  bgColor?: string | null;
};

const IdCardSkeleton: React.FC<IdCardSkeletonProps> = ({ bgColor }) => {
  return (
    <ConfigProvider
      theme={{
        components: {
          Skeleton: {
            gradientFromColor: "#404040",
            gradientToColor: "#606060",
          },
        },
      }}
    >
      <div
        className={`h-[168px] w-full rounded-lg p-6 ${bgColor ?? ""}`}
        style={{
          boxShadow: `-1px -2px 1px rgba(255, 255, 255, 0.2),
            1px -2px 1px rgba(255, 255, 255, 0.15),
            1px 2px 2px rgba(255, 255, 255, 0.1)`,
          transform: "perspective(1000px) rotateX(2deg)",
          willChange: "transform",
        }}
      >
        <Flex vertical justify="center" align="center" className="h-full gap-1">
          <div className="mt-1 w-full flex min-w-0 flex-1 flex-col gap-1">
            <Skeleton.Input
              size="small"
              style={{ width: "100%", height: "5px" }}
              active
            />
            <Skeleton.Input
              size="small"
              style={{ width: "100%",  height: "3px" }}
              active
            />
              <Skeleton.Input
              size="small"
              style={{ width: "100%",  height: "5px" }}
              active
            />
          </div>


          <Flex className="w-full" justify="space-between" align="center">

<div className="w-[70%]  flex flex-wrap">
  <Skeleton.Input
              size="small"
              style={{ width: "50%", marginRight: "3px", height: "4px" }}
              active
            />
            
            <Skeleton.Input
              size="small"
              style={{ width: "50%",  height: "4px" }}
              active
            />
              <Skeleton.Input
              size="small"
              style={{ width: "50%",  height: "4px" }}
              active
            />
</div>
            <div className="mb-2">
              <Skeleton.Node
                active
                style={{
                  width: 54,
                  minWidth: 54,
                  height: 54,
                  borderRadius: 2,
                  flexShrink: 0,
                }}
              />
            </div>
          </Flex>
        </Flex>
      </div>
    </ConfigProvider>
  );
};

export default IdCardSkeleton;
